import axios from "axios";

const DEBUG = false

let URL
if (DEBUG) {
    URL = 'http://127.0.0.1:8000/';
} else {
    URL = '/api/';  // relative: same-origin Apache (admin.atflowers.com and sandbox). Matches the served prod bundle since 2026-07-13.
}

export const AUTH_OBTAIN_ENDPOINT = 'auth/';
export const AUTH_VERIFY_ENDPOINT = 'verify/;';
export const AUTH_REFRESH_ENDPOINT = 'auth/refresh/';
export const AUTH_CURRENT_USER_ENDPOINT = 'currentuser/';
export const API_URL = URL;
export const backend = axios.create({baseURL : API_URL});
